import { atom } from "recoil";

const clientExerciseReportsState = atom({
  key: "clientExerciseReportsState",
  default: null,
});

export default clientExerciseReportsState;
